import { render, staticRenderFns } from "./VaultAccount.vue?vue&type=template&id=20efe44e&"
import script from "./VaultAccount.vue?vue&type=script&lang=js&"
export * from "./VaultAccount.vue?vue&type=script&lang=js&"
import style0 from "./VaultAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports